document.addEventListener('DOMContentLoaded', function () {
  const dropdownToggle = document.querySelector('[data-toggle-dropdown]');
  const dropdownMenu = document.querySelector('[data-dropdown-menu]');
  const dropdownLabel = dropdownToggle.querySelector('[data-sorting-label]');
  const articles = document.querySelectorAll('[data-blog-article]');

  const selectedTag = dropdownLabel.textContent.trim().toLowerCase();
  const initiallySelected = dropdownMenu.querySelector(`[data-tag="${selectedTag}"]`);
  if (initiallySelected) {
    initiallySelected.classList.add('hidden');
  }

  dropdownToggle.addEventListener('click', (event) => {
    event.stopPropagation();
    dropdownMenu.style.display = dropdownMenu.style.display === 'block' ? 'none' : 'block';
  });

  dropdownMenu.addEventListener('click', (event) => {
    event.stopPropagation();
    const selectedTag = event.target.getAttribute('data-tag');
    if (selectedTag) {
      dropdownLabel.textContent = event.target.textContent;
      const currentSelected = dropdownMenu.querySelector('.hidden');
      if (currentSelected) {
        currentSelected.classList.remove('hidden');
      }
      event.target.classList.add('hidden');
      
      articles.forEach((article) => {
        if (selectedTag === 'all' || article.getAttribute('data-tag') === selectedTag) {
          article.style.display = 'block';
        } else {
          article.style.display = 'none';
        }
      });
      dropdownMenu.style.display = 'none';
    }
  });

  document.addEventListener('click', () => {
    dropdownMenu.style.display = 'none';
  });
});

const openPopup = document.querySelector('[data-action]');
const popupOverlay = document.querySelector('[data-popup-overlay]');
const closePopup = document.querySelector('[data-action-close]');

openPopup.addEventListener("click", () => {
  popupOverlay.style.display = "flex";
  popupOverlay.classList.add('popup-active');
});

closePopup.addEventListener("click", () => {
  popupOverlay.style.display = "none";
  popupOverlay.classList.remove('popup-active');
});

popupOverlay.addEventListener("click", (e) => {
  if (e.target === popupOverlay) {
    popupOverlay.style.display = "none";
    popupOverlay.classList.remove('popup-active');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  let live_url = window.location.href;
  let result = live_url.includes('contact_posted=true');

  if (result) {
    popupOverlay.style.display = "flex";
    popupOverlay.classList.add('popup-url-active');
    
    popupOverlay.addEventListener('click', function () {
      removeQueryParameter('contact_posted');
      popupOverlay.classList.remove('popup-url-active');
    });
  } else {
    popupOverlay.classList.remove('popup-url-active');
    popupOverlay.style.display = "none";
  }
});

function removeQueryParameter(parameterName) {
  const urlParts = location.href.split('?');
  if (urlParts.length === 2) {
  const baseURL = urlParts[0];
    const queryString = urlParts[1];
    const queryParams = new URLSearchParams(queryString);
    
    if (queryParams.has(parameterName)) {
      queryParams.delete(parameterName);
      const newURL = queryParams.toString() ? `${baseURL}?${queryParams.toString()}` : baseURL;
      history.pushState(null, null, newURL);
    }
  }
}

